package com.xtream.data_kmp

import com.xtream.data_kmp.dto.LiveCategory


// Categories


// Info
const val CNT_VOD_INFO: String = "get_vod_info"
const val CNT_SERIES_INFO: String = "get_series_info"
object AllConst {

    //
    const val AD_BILLBOARD= "billboard_mob_menu"
    const val AD_LEADERBOARD= "leaderboard_tv_menu"


    //streams
    const val  CNT_LIVE_STREAMS_ACTION:String = "get_live_streams"
    const val  CNT_VOD_STREAMS_ACTION :String= "get_vod_streams"
    const val  CNT_SERIES_STREAMS_ACTION :String= "get_series"
 //categories
    const val  CNT_LIVE_CATEGORIES_ACTION:String = "get_live_categories"
    const val  CNT_SERIES_CATEGORIES_ACTION:String = "get_series_categories"
    const val  CNT_VOD_CATEGORIES_ACTION:String = "get_vod_categories"
 //info
    const val CNT_VOD_INFO:String = "get_vod_info"
    const val CNT_SERIES_INFO:String = "get_series_info"


    //



    //exceptions
    const val SOCKET_TIMEOUT_EXCEPTION:String= "Timeout - Please check your internet connection"

    const val UNKNOWN_HOST_EXCEPTION:String= "Unable to make a request. Please check your internet connection"

    const val CONNECTION_SHUTDOWN_EXCEPTION:String="Connection shutdown. Please check your internet connection"

    const val CONNECTION_EXCEPTION:String= "Can't connect to the server."
    const val IO_EXCEPTION:String= "Server is unreachable, please try again later."
    const val USER_NOT_FOUND_EXCEPTION:String= "User Not Found."
    const val JSON_CONVERT_EXCEPTION:String= "Error: Can't parse data at this time"

    const val SSL_HANDSHAKE_EXCEPTION:String= "SSL Certificate Error"
     const val SYSTEM_TIME_INVALID:String= "System time is invalid, please check date and time settings"



    const val UNKNOWN_EXCEPTION:String=  "Error"
    const val ACCOUNT_EXPIRED_EXCEPTION:String=  "The account is Expired"
    const val ACCOUNT_UNAVAILABLE_EXCEPTION:String=  "The account is unavailable"


    //streams
    const val STREAM_TYPE="STREAM_TYPE"

    const val LIVE_STREAMS="live"
    const val VODS_STREAMS="movie"
    const val SERIES_STREAMS="series"
    const val  STREAM_ID:String = "streamId"
    const val  STREAM_URL:String = "streamURL"
    const val  IS_ON_DEMAND:String = "IS_ON_DEMAND"
    const val  STATUS:String = "IS_ON_DEMAND"
    //extra categories

    const val  ALL_CATEGORIES_ID:Long = -1000
    const val  FAV_CATEGORIES_ID:Long = -2000
    const val  WATCHED_CATEGORIES_ID:Long = -3
    const val  PAGING_PAGE_SIZE:Int = 15
    const val  PAGING_MIN_PAGE_SIZE:Int = 3
    const val  RECOMMENDATIONS_CONTENT_SIZE:Int = 25

    val defaultCategories= listOf(
        LiveCategory(
            ALL_CATEGORIES_ID.toInt(), "All"
        ), LiveCategory(FAV_CATEGORIES_ID.toInt(), "Favorites")
    )




   //prefs

        const val RESUME_LAST_PLAYED_ACTIVITY_KEY = "resume_last_played_activity_key"
        const val LAST_SCREEN_KEY = "last_screen_key"
        const val CLEAR_WATCHED_LIVE_PREF = "clear_watched_live_pref"
        const val CLEAR_WATCHED_SERIES_PREF = "clear_watched_series_pref"
        const val CLEAR_WATCHED_VOD_PREF = "clear_watched_vod_pref"
        const val LOGOUT_KEY = "logout_key"
        const val USERNAME_KEY = "logout_key" // Same value as LOGOUT_KEY
        const val IS_TRIAL_KEY = "is_trial_key"
        const val ACTIVE_CONNECTIONS_KEY = "active_connections_key"
        const val MAX_CONNECTIONS_KEY = "max_connections_key"
        const val CREATED_DATE_KEY = "created_date_key"
        const val EXP_DATE_KEY = "exp_date_key"
        const val LIVE_STREAM_FORMAT_KEY = "live_stream_format_key"
        const val FORCE_PLAYER_REFRESH_ON_UPDATE_KEY = "force_player_refresh_on_update_key"
        const val LAST_PLAYED_STREAM_KEY = "last_played_stream_key"
        const val LAST_PLAYED_CATEGORY_KEY = "last_played_category_key"
        const val LAST_REFRESH_KEY = "last_refresh_key"
        const val LIVE_STREAM_DECODER_TYPE_KEY = "live_stream_decoder_type_key"
        const val PLAYLIST_REFRESH_INTERVAL_KEY = "playlist_refresh_interval_key"
        const val REFRESH_PLAYLIST_PREF_KEY = "refresh_playlist_pref"
        const val VIDEO_SCALING_MODE_KEY = "video_scaling_mode_key"



    const val  ROOM_TOP_QUERY_LIMIT:Int = 10
    const val  ROOM_RECENT_QUERY_LIMIT:Int = 20
    const val  ROOM_WATCHED_QUERY_BROWSE_LIMIT:Int = 7



}